import request from "@utils/request";


export function getUserInfo() {
  return request.get("/userinfo");
}

export function login(data) {
  return request.post("/padAdmin/login", data, { login: false });
}

export function logout() {
  return request.get("/padAdmin/logout", null, { login: true });
}

export function getCompanyServices() {
  return request.get("/padAdmin/getServices", null, { login: true });
}

export function getCompanyInfo() {
  return request.get("/padAdmin/getCompanyInfo", null, { login: true });
}

export function createCompanyPerson(data) {
  return request.post("/padAdmin/createPerson", data, { login: true });
}
